/**
 * Firebase configuration for Fantomize
 *
 * Uses environment variables to keep API keys secure.
 * Never commit .env file to git!
 */
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';

// Firebase configuration from environment variables
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};

// Validate that required config is present
const isFirebaseConfigured = firebaseConfig.apiKey && firebaseConfig.projectId;

if (!isFirebaseConfigured) {
  console.warn(
    'âš ï¸ [Firebase] Configuration missing. Authentication features will be disabled.\n' +
    'Add Firebase environment variables to enable auth:\n' +
    '- VITE_FIREBASE_API_KEY\n' +
    '- VITE_FIREBASE_PROJECT_ID\n' +
    '- VITE_FIREBASE_AUTH_DOMAIN\n' +
    'The app will continue to work without authentication.'
  );
} else {
  console.log('[Firebase] Configuration found, initializing...');
}

// Initialize Firebase only if configured
const app = isFirebaseConfigured ? initializeApp(firebaseConfig) : null;

if (app) {
  console.log('[Firebase] Successfully initialized:', { projectId: firebaseConfig.projectId });
} else {
  console.warn('[Firebase] Skipped initialization (no config)');
}

// Initialize Firebase Authentication (null if not configured)
export const auth = app ? getAuth(app) : null;

// Initialize Analytics (optional, only in production)
let analytics = null;
if (app && typeof window !== 'undefined' && import.meta.env.PROD) {
  analytics = getAnalytics(app);
}

export { analytics };
export default app;


